// extracted by mini-css-extract-plugin
export var alignCenter = "_9l-d";
export var bannerShown = "_9l-6";
export var buttonContent = "_9l-0";
export var cardList = "_9l-1";
export var centerContent = "_9l-2";
export var chevron = "_9l-3";
export var closePanelButton = "_9l-k";
export var conversationContextContainer = "_9l-l";
export var conversationDetailContainer = "_9l-4";
export var detailWrapper = "_9l-7";
export var dropdownButton = "_9l-e";
export var dropdownTitle = "_9l-9";
export var fullHeight = "_9l-5";
export var hidden = "_9l-a";
export var icon = "_9l-b";
export var mergeSuggestionWrapper = "_9l-m";
export var panel = "_9l-i";
export var portalButtonsWrapper = "_9l-c";
export var right = "_9l-j";
export var tableSummaryContainer = "_9l-8";
export var tableSummaryHeader = "_9l-g";
export var threeDotsButton = "_9l-f";
export var wide = "_9l-h";